module.exports = __webpack_public_path__ + "static/media/IC_capability_mapping.a60d6a8c.svg";